import { isWeb } from '@helpers';
import { notchTop } from '@components/frame';

export const useDashboardScreenTopOffset = (headerMarginTop: number) => {
  const additionalOffset = isWeb ? 0 : notchTop ? notchTop : headerMarginTop;
  return headerMarginTop + additionalOffset;
};
